import React, {Component} from "react";
import {Redirect} from 'react-router';
import Datetime from "react-datetime";
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {serverError} from '../../redux/global'
// import Autocomplete from '@material-ui/lab/Autocomplete';
import api from "../../api/Api";
import {NavLink} from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/core components

import SearchComponent from "components/Search/AutoCompletePatient.jsx";
import AutoCompleteTest from "components/Search/AutoCompleteTest.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum,
    verifyNumber,
    verifyPhoneNumber,
    isClinicMasterOrClinic, getClinicUserId, clinicmaster_id, dashboardRouter, timing, parseQueryParams
} from '../../util/globalHelper'
import moment from 'moment'
// style for this view
import Loader from '../../components/Loader'
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import SelectAutoCompleteCity from "components/Forms/ClinicForm/selectAutoCompleteCity.jsx"
import SelectAutoCompleteState from "components/Forms/ClinicForm/selectAutoCompleteState.jsx"

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};

class AddTests extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            mode: "",
            email: "",
            emailState: "",
            addressline: "",
            addresslineState: "",
            locality: "",
            localityState: "",
            pincode: "",
            pincodeState: "",
            selectedOptionState: '',
            selectedOptionCity: '',
            selectedcityvalue: '',
            selectedstatevalue: '',
            selectedcitylabel: 'Delhi',
            selectedstatelabel: 'Delhi',
            paid: false,
            home_collection_allowed: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            selectedIndex: "",
            usernameState: "",
            password: "",
            passwordState: "",
            doctor_id: "",
            service: "",
            subType: "",
            imageurl: '',
            clinicList: null,
            slot: "",
            clinicmaster_id: null,
            clinic_id: null,
            clinicMasterList: null,
            clinicsData: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            tests: [],
            doctorList: null,
            serviceList: null,
            clinicDetail: null,
            timeSlot: null,
            timeIntervalOpen: null,
            timeIntervalClose: null,
            timingStatic: [],
            testData: [],
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            patient: null,
            defaultDate: ""
        };
        this.typeClick = this.typeClick.bind(this)
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.handleChangeTest = this.handleChangeTest.bind(this)
        this.getSuggestionTestValue = this.getSuggestionTestValue.bind(this)
        this.removeTest = this.removeTest.bind(this)
        this.setIndex = this.setIndex.bind(this)
        this.addTests = this.addTests.bind(this)
        this.setPhoneNumber = this.setPhoneNumber.bind(this)

    }

    handleSelectStateChange(selectedOptionState) {
        this.setState({selectedOptionState});
        if (selectedOptionState) {
            this.setState({
                selectedstatevalue: selectedOptionState.value,
                selectedstatelabel: selectedOptionState.label
            });
        }
    }

    handleSelectCityChange(selectedOptionCity) {
        this.setState({selectedOptionCity});
        if (selectedOptionCity) {
            this.setState({selectedcityvalue: selectedOptionCity.value, selectedcitylabel: selectedOptionCity.label});
        }
    }


    addTests() {
        let a = [{name: ""}];
        let b = this.state.tests.concat(a);
        this.setState({tests: b});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    handleImageUrl(url) {
        this.setState({
            imageurl: url,
            report_link: this.state.report_link.concat({"link": url, "type": "Lab Report"})
        }, () => {
            this.setState({imageurl: ''})
        });
    }

    setIndex(index) {
        this.setState({selectedIndex: index})
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            clickedId: suggestion._id,
            patient: suggestion,
            name: suggestion.user_id.name ? suggestion.user_id.name : "N/A",
            nameState: 'success',
            contactNumber: suggestion.user_id.contact,
            contactNumberState: 'success',
            email: suggestion.user_id.email,
            emailState: 'success',
        });
        return suggestion.user_id.contact ? suggestion.user_id.contact : "N/A"
    }

    getSuggestionTestValue = (suggestion, index) => {
        this.setState({
            test_id: suggestion._id,
            test: suggestion.name ? suggestion.name : "N/A"
        });
        this.handleChangeTest(suggestion, 'name', this.state.selectedIndex)
        return suggestion.discounted_price !== 0 && suggestion.name ? suggestion.name + " ( ₹" + suggestion.discounted_price + ")" : suggestion.name ? suggestion.name + " ( ₹" + suggestion.total + ")" : "N/A"

    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    currentDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }


    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.patientID, this.props.id.match.params.DateTime);
        this.setState({clickedId: this.props.id.match.params.patientID})

    }

    CallReadApi = (id, date) => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
                this.setState({clinicMasterList: json.data.data})
            }).catch(error => {
                this.props.serverError(true);
            })
            : this.setState({
                clinicMasterList: {},
                clinicmaster_id: clinicmaster_id(),
                clinic_id: getClinicUserId() === "" ? null : getClinicUserId(),
            }, () => {
                if (this.state.clinic_id !== null) {
                    api.getClinicById(getClinicUserId(), {}).then(json => {
                        this.setState({clinicDetail: json.data.data});
                        date ? this.setState({
                            date: this.formatDate(parseInt(date)),
                            timeSlot: json.data.data && json.data.data.clinic_timings ? json.data.data.clinic_timings[`${new Date(parseInt(date)).getDay() > 0 ? new Date(parseInt(date)).getDay() - 1 : 6}`] : null,
                            finalTime: []
                        }, () => {
                            if (this.state.timeSlot !== null)
                                this.setState({
                                    timeIntervalOpen: this.state.timingStatic.find(o => o.time === this.state.timeSlot.open_time),
                                    timeIntervalClose: this.state.timingStatic.find(o => o.time === this.state.timeSlot.close_time),
                                }, () => {
                                    if (this.state.timeIntervalOpen !== undefined && this.state.timeIntervalClose !== undefined)
                                        this.setState({finalTime: this.newArray(this.state.timeIntervalClose.count, this.state.timeIntervalOpen.count)})
                                })
                        }) : this.handleChangeStartDate(moment())
                    }).catch(error => {
                        this.props.serverError(true);
                    })

                }
            });
        this.setState({date: this.currentDate()});
        this.setState({timingStatic: timing});
        api.getAllDoctors().then(json => {
            this.setState({doctorList: json.data.data})
        }).catch(error => {
            this.props.serverError(true);
        });
        api.getPackages().then(json => {
            this.setState({serviceList: json.data.data})
        }).catch(error => {
            this.props.serverError(true);
        });
        var postBody = {

            "clinic_master_id": "",
            "_id": id
        };
        if (id) {
            api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
                this.setState({patientDetail: json.data.data[0]}, () => {
                    this.setState({
                        name: this.state.patientDetail.user_id.name,
                        contactNumber: this.state.patientDetail.user_id.contact,
                        email: this.state.patientDetail.user_id.email
                    })
                })
            }).catch(error => {
                this.props.serverError(true);
            })
        }

        if (this.props.id.location.search !== "") {
            let JDPatient = parseQueryParams(this.props.id.location.search)
            this.setState({
                name: JDPatient.name ? JDPatient.name : "",
                contactNumber: JDPatient.mobile ? JDPatient.mobile : "",
                autoCompleteValue: JDPatient.mobile ? JDPatient.mobile : ""
            })
        }
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        // if (e.target.name === "clinic_id") {
        //     this.setState({defaultDate: moment()})
        //     this.handleChangeStartDate(moment())
        // }

        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : "",

        };

        api.getTests(postBody).then(json => {
            this.setState({testData: json.data.data}, () => {
                this.setState({
                    testData: this.state.testData.map(item => {
                        // patientList: this.state.data.data.map(item => {
                        return {
                            "_id": item._id,
                            "name": item.master_test_id ? item.master_test_id.name : "-",
                            "clinic_id": item.clinic_id ? item.clinic_id._id : "-",
                            "description": item.master_test_id ? item.master_test_id.description : "-",
                            "total": item.total,
                            "discounted_price": item.discounted_price,
                        }
                    })
                })
            })
        });
    }

    componentDidUpdate() {
        if (this.state.clinic_id !== null && (this.state.clinicDetail === null || this.state.clinicDetail !== null && this.state.clinicDetail.clinic_id !== this.state.clinic_id))
            api.getClinicById(this.state.clinic_id, {}).then(json => {
                this.setState({clinicDetail: json.data.data}, () => this.handleChangeStartDate(moment())
                )
            }).catch(error => {
                this.props.serverError(true);
            });

    }

    setPhoneNumber(value) {
        this.setState({autoCompleteValue: value})
    }

    render() {
        const {classes} = this.props;
        const {clinicList, clinicsData, clinicMasterList, defaultDate} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData.length > 0 && this.state.clinicsData[0].clinic_master_id && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.clinicMasterList && this.state.doctorList && this.state.serviceList)
            return (
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className={classes.cardTitle}>Book Test</h4>
                                    </CardText>

                                </CardHeader>
                                <CardBody>
                                    <form>
                                        {/*New Code Added*/}
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} className="centerDiv">
                                                {isClinicMasterOrClinic() === "" ?
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id"
                                                            className={classes.selectLabel}>
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.clinicmaster_id === null ? "" : this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >{clinicMasterList.map(item => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             value={item.clinicmaster_id}>
                                                                {item.clinicmaster_name}  </MenuItem>
                                                        })}

                                                        </Select>
                                                    </FormControl> : null}
                                            </GridItem>
                                            <GridItem xs={12} sm={6} className="centerDiv">
                                                {(isClinicMasterOrClinic() === "" || isClinicMasterOrClinic()) && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="clinic_id"
                                                            className={classes.selectLabel}>
                                                            Clinic
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.clinic_id === null ? "" : this.state.clinic_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinic_id",
                                                                id: "clinic_id"
                                                            }}>
                                                            {clinicsData.map(item => {
                                                                return <MenuItem key={Math.random()}
                                                                                 classes={{root: classes.selectMenuItem}}
                                                                                 value={item._id}>
                                                                    {item.name}  </MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl> : null}
                                            </GridItem>
                                            {/*Personal Details*/}
                                            <GridItem xs={12} sm={6}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12}>
                                                        {this.props.id.match.params.patientID || this.props.id.location.search !== "" ?
                                                            <CustomInput
                                                                labelText=" Phone Number"
                                                                success={this.state.contactNumberState === "success"}
                                                                error={this.state.contactNumberState === "error"}
                                                                id="url"
                                                                formControlProps={{fullWidth: true, required: true}}
                                                                inputProps={{
                                                                    onChange: event => this.change(event, "contactNumber", "phonenumber"),
                                                                    value: this.state.contactNumber,

                                                                }}
                                                            /> :
                                                            <SearchComponent setPhoneNumber={this.setPhoneNumber}
                                                                             name={this.state.name}
                                                                             getSuggestionValue={this.getSuggestionValue}/>}
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <CustomInput
                                                            labelText="Name"
                                                            success={this.state.nameState === "success"}
                                                            error={this.state.nameState === "error"}
                                                            id="name"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                                required: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "name", "name"),
                                                                value: this.state.name,
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <CustomInput
                                                            labelText="Email"
                                                            success={this.state.emailState === "success"}
                                                            error={this.state.emailState === "error"}
                                                            id="email"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "email", "email"),
                                                                value: this.state.email,

                                                            }}
                                                        />
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <GridContainer>
                                                    {/*Appointment Details*/}
                                                    <GridItem xs={12} sm={12}>
                                                        <FormControl fullWidth className={classes.selectFormControl}>
                                                            {this.state.clinicmaster_id && this.state.clinic_id !== "" && this.state.clinicDetail ?
                                                                <div>
                                                                    <Datetime
                                                                        timeFormat={false}
                                                                        defaultValue={new Date()}
                                                                        //value={this.state.date}
                                                                        name="date"
                                                                        id="appointment_date"
                                                                        dateFormat={"DD MMMM, YYYY"}
                                                                        closeOnSelect={true}
                                                                        onChange={event => this.handleChangeStartDate(event)}
                                                                        inputProps={{placeholder: "Appointment Date"}}/>
                                                                </div> : null}
                                                        </FormControl>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <FormControl
                                                            fullWidth
                                                            className={classes.selectFormControl}>
                                                            <InputLabel
                                                                htmlFor="slot"
                                                                className={classes.selectLabel}>
                                                                Available Time Slots
                                                            </InputLabel>
                                                            <Select
                                                                MenuProps={{className: classes.selectMenu}}
                                                                classes={{select: classes.select}}
                                                                onChange={this.onChangeSelect}
                                                                value={this.state.slot}
                                                                inputProps={{name: "slot", id: "slot"}}>
                                                                {this.state.finalTime && this.state.finalTime.length > 0 ? this.state.finalTime.map((item) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     classes={{root: classes.selectMenuItem}}
                                                                                     value={item.value}>
                                                                        {item.value}  </MenuItem>
                                                                }) : "No Time Slot"}
                                                            </Select>
                                                        </FormControl>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <CustomInput
                                                            labelText="Reason for Appointment"
                                                            success={this.state.descriptionState === "success"}
                                                            error={this.state.descriptionState === "error"}
                                                            id="name"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                                required: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "description", "name"),
                                                                value: this.state.description,
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <FormControl
                                                            fullWidth
                                                            className={classes.selectFormControl}>
                                                            <InputLabel
                                                                htmlFor="mode"
                                                                className={classes.selectLabel}>
                                                                Payment Mode
                                                            </InputLabel>
                                                            <Select
                                                                MenuProps={{className: classes.selectMenu}}
                                                                classes={{select: classes.select}}
                                                                onChange={this.onChangeSelect}
                                                                value={this.state.mode}
                                                                inputProps={{name: "mode", id: "mode"}}>
                                                                <MenuItem classes={{root: classes.selectMenuItem}}
                                                                          value={"Pay at Center/Cash"}>
                                                                    Pay at Center/Cash
                                                                </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <FormControl
                                                            fullWidth
                                                            className={classes.selectFormControl}>
                                                            <InputLabel
                                                                htmlFor="home_collection_allowed"
                                                                className={classes.selectLabel}>
                                                                Collection Type
                                                            </InputLabel>
                                                            <Select
                                                                MenuProps={{className: classes.selectMenu}}
                                                                classes={{select: classes.select}}
                                                                onChange={this.onChangeSelect}
                                                                value={this.state.home_collection_allowed}
                                                                inputProps={{
                                                                    name: "home_collection_allowed",
                                                                    id: "home_collection_allowed"
                                                                }}>
                                                                <MenuItem classes={{root: classes.selectMenuItem}}
                                                                          value={false}>
                                                                    Visit Clinic
                                                                </MenuItem> <MenuItem
                                                                classes={{root: classes.selectMenuItem}}
                                                                value={true}>
                                                                Home Collection
                                                            </MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </GridItem>
                                                    {this.state.home_collection_allowed !== "" && JSON.parse(this.state.home_collection_allowed) === true ?
                                                        <React.Fragment>
                                                            <GridItem xs={12} sm={12} md={12}>
                                                                <h6>Address</h6>
                                                                <FormControl
                                                                    fullWidth
                                                                    className={classes.selectFormControl}>
                                                                <CustomInput
                                                                    labelText="Address Line 1"
                                                                    success={this.state.addresslineState === "success"}
                                                                    error={this.state.addresslineState === "error"}
                                                                    id="addressline"
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        onChange: event =>
                                                                            this.change(event, "addressline", "novalidation", "optional")
                                                                    }}
                                                                />
                                                                </FormControl>
                                                            </GridItem>
                                                            <GridItem xs={12} sm={12} md={12}>
                                                                <CustomInput
                                                                    labelText="Locality"
                                                                    success={this.state.localityState === "success"}
                                                                    error={this.state.localityState === "error"}
                                                                    id="locality"
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        onChange: event =>
                                                                            this.change(event, "locality", "novalidation", "optional")
                                                                    }}
                                                                />
                                                            </GridItem>
                                                            <br />
                                                            <GridItem xs={12} sm={12} md={12}>
                                                                <GridContainer>
                                                                    <GridItem xs={12} sm={12} md={12}>
                                                                        <br />
                                                                        <label>City</label>
                                                                        <SelectAutoCompleteCity
                                                                            handleSelectCityChange={this.handleSelectCityChange.bind(this)}
                                                                            selectedcityvalue={this.state.selectedcityvalue}/>
                                                                        <br />
                                                                    </GridItem>
                                                                    <GridItem xs={12} sm={12} md={12}>
                                                                        <br />
                                                                        <label>State</label>
                                                                        <SelectAutoCompleteState
                                                                            handleSelectStateChange={this.handleSelectStateChange.bind(this)}
                                                                            selectedstatevalue={this.state.selectedstatevalue}/>
                                                                        <br />
                                                                    </GridItem>
                                                                </GridContainer>
                                                            </GridItem>
                                                            <GridItem xs={12} sm={12} md={12}>
                                                                <CustomInput
                                                                    labelText="Pincode"
                                                                    success={this.state.pincodeState === "success"}
                                                                    error={this.state.pincodeState === "error"}
                                                                    id="pincode"
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        onChange: event => this.change(event, "pincode", "pincode", "optional")
                                                                    }}
                                                                />
                                                            </GridItem>
                                                        </React.Fragment> : null}
                                                </GridContainer>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>

                                            <GridItem xs={12} sm={6}>
                                                {/*    <br/><br/>*/}
                                                {/*    <label>Reason for Appointment</label>*/}
                                                {/*    <TextField*/}
                                                {/*        className="width-full"*/}
                                                {/*        placeholder=""*/}
                                                {/*        multiline={true}*/}
                                                {/*        rows={5}*/}
                                                {/*        id="name"*/}
                                                {/*        rowsMax={10}*/}
                                                {/*        inputProps={{*/}
                                                {/*            onChange: event =>*/}
                                                {/*                this.change(event, "description", "name")*/}
                                                {/*        }}*/}
                                                {/*    />*/}
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>

                                                <GridContainer className={classes.justifyContentCenter}
                                                               style={{
                                                                   justifyContent: 'center',
                                                                   textAlign: 'center',
                                                                   marginBottom: '20px'
                                                               }}>

                                                    <ExpansionPanel className="width-full" defaultExpanded>
                                                        <ExpansionPanelSummary
                                                            expandIcon={<ExpandMoreIcon/>}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header">
                                                            <Typography
                                                                className={classes.heading}>Tests</Typography>
                                                        </ExpansionPanelSummary>
                                                        <ExpansionPanelDetails>
                                                            <Typography className="width-full" defaultExpanded>
                                                                {this.state.tests.map((item, index) => {
                                                                    return <div className="width-full list-inline"
                                                                                style={{display: 'inline-flex'}}
                                                                                key={"test" + index}>
                                                                        <GridItem xs={12} sm={12}
                                                                                  style={{display: 'inline-flex'}}>
                                                                            <AutoCompleteTest
                                                                                setPhoneNumber={this.setPhoneNumber}
                                                                                name={this.state.name}
                                                                                index={index}
                                                                                clinic_id={this.state.clinic_id}
                                                                                setIndex={this.setIndex}
                                                                                data={this.state.testData}
                                                                                getSuggestionValue={this.getSuggestionTestValue}
                                                                            />


                                                                            <Icon
                                                                                style={{
                                                                                    fontSize: 20, padding: '15px',
                                                                                    margin: '5%'
                                                                                }} onClick={() => {
                                                                                this.removeTest(index)
                                                                            }}>close</Icon>
                                                                            {/*<Autocomplete*/}
                                                                            {/*    id="country-select-demo"*/}
                                                                            {/*    style={{ width: 300 }}*/}
                                                                            {/*    options={this.state.testData}*/}
                                                                            {/*    classes={{*/}
                                                                            {/*        option: classes.option,*/}
                                                                            {/*    }}*/}
                                                                            {/*    onChange={e => this.handleChangeTest(e, 'name', index)}*/}
                                                                            {/*    autoHighlight*/}
                                                                            {/*    getOptionLabel={(option) => option.name ? option.name + "  " + (" (INR ") + option.total + ")" : "No Name"}*/}
                                                                            {/*    renderOption={(option) => (*/}
                                                                            {/*        <React.Fragment>*/}
                                                                            {/*            {option.name ? option.name + "  " + (" (INR ") + option.total + ")" : "No Name"}*/}
                                                                            {/*        </React.Fragment>*/}
                                                                            {/*    )}*/}
                                                                            {/*    renderInput={(params) => (*/}
                                                                            {/*        <TextField*/}
                                                                            {/*            {...params}*/}
                                                                            {/*            label="Choose test"*/}
                                                                            {/*            variant="outlined"*/}
                                                                            {/*            inputProps={{*/}
                                                                            {/*                ...params.inputProps,*/}
                                                                            {/*                autoComplete: 'new-password', // disable autocomplete and autofill*/}
                                                                            {/*            }}*/}
                                                                            {/*        />*/}
                                                                            {/*    )}*/}
                                                                            {/*/>*/}
                                                                            {/*<FormControl*/}
                                                                            {/*    fullWidth>*/}
                                                                            {/*    <InputLabel*/}
                                                                            {/*        htmlFor="clinic_id">*/}
                                                                            {/*        Tests*/}
                                                                            {/*    </InputLabel>*/}
                                                                            {/*    <Select*/}
                                                                            {/*        value={item.name}*/}
                                                                            {/*        onChange={e => this.handleChangeTest(e, 'name', index)}*/}
                                                                            {/*        inputProps={{*/}
                                                                            {/*            name: "name",*/}
                                                                            {/*            id: "name"*/}
                                                                            {/*        }}*/}
                                                                            {/*    >*/}
                                                                            {/*        <MenuItem*/}
                                                                            {/*            disabled*/}
                                                                            {/*        >*/}
                                                                            {/*            Select Test*/}
                                                                            {/*        </MenuItem>*/}
                                                                            {/*        {this.state.clinic_id !== "" && this.state.testData.filter(a => a.clinic_id === this.state.clinic_id).length > 0 ? this.state.testData.filter(a => a.clinic_id === this.state.clinic_id).map((x) => {*/}
                                                                            {/*            return <MenuItem*/}
                                                                            {/*                key={Math.random()}*/}
                                                                            {/*                style={{height: "1.8em"}}*/}
                                                                            {/*                value={x._id}>{x.name ? x.name + "  " + (" (INR ") + x.total + ")" : "No Name"}</MenuItem>*/}
                                                                            {/*        }) : this.state.testData.map((x) => {*/}
                                                                            {/*            return <MenuItem*/}
                                                                            {/*                key={Math.random()}*/}
                                                                            {/*                style={{height: "1.8em"}}*/}
                                                                            {/*                value={x._id}>{x.name ? x.name + "  " + (" (INR ") + x.total + ")" : "No Name"}</MenuItem>*/}
                                                                            {/*        })}*/}
                                                                            {/*    </Select>*/}
                                                                            {/*</FormControl>*/}
                                                                        </GridItem>
                                                                    </div>
                                                                })}
                                                                <GridItem xs={12} sm={6}>
                                                                    <Button block size="lg" color="warning"
                                                                            onClick={(e) => {
                                                                                if (this.state.clinic_id) {
                                                                                    this.addTests(e)
                                                                                } else {
                                                                                    var msgcolor = {
                                                                                        message: "Please select clinic!",
                                                                                        color: "danger"
                                                                                    };
                                                                                    this.props.id.generateNotification(msgcolor);
                                                                                }
                                                                            }}>Add
                                                                        Test
                                                                    </Button></GridItem>
                                                                <GridItem xs={12} sm={6}>
                                                                </GridItem>
                                                            </Typography>
                                                        </ExpansionPanelDetails>
                                                    </ExpansionPanel>
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <h4 className="text-center margin-t-30"
                                                    style={{marginTop: '100px !important'}}><b>TOTAL :
                                                    ₹ {this.calculateTotal()}</b></h4>
                                            </GridItem>

                                        </GridContainer>


                                        <br/>
                                    </form>
                                    <br/>

                                    <br/>

                                    <br/>

                                </CardBody>
                                <CardFooter className={"centerDiv"}>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={12} sm={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={3}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={12} sm={3}>
                                            <NavLink to={dashboardRouter(`/appointment/readAppointments`)}>
                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                        <GridItem xs={12} sm={3}>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    removeTest(i) {
        let array = this.state.tests;
        delete array[i];

        // var index = array.indexOf(i);
        // array.splice(index, 1);
        this.setState({tests: array})

    }

    change(event, stateName, type, stateNameEqualTo, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            default:
                break;
        }
    }

    typeClick() {
        if (this.state.name === "") {
            this.setState({nameState: "error"});
        }
        if (this.state.email === "") {
            this.setState({emailState: "error"});
        }
        if (this.state.contactNumber === "") {
            this.setState({contactNumberState: "error"});
        }
        var address = {
            "addressline": this.state.addressline,
            "locality": this.state.locality,
            "city": this.state.selectedcitylabel,
            "state": this.state.selectedstatelabel,
            "pincode": this.state.pincode
        }
        var data = {
            "clinic_master_id": this.state.clinicmaster_id,
            "clinic_id": this.state.clinic_id,
            "patient_id": this.state.clickedId,
            "local_date_string": this.state.date,
            "start": this.state.date,
            "name": this.state.name,
            "contact": this.state.autoCompleteValue,
            "email": this.state.email,
            "home_collection_allowed": this.state.home_collection_allowed !== "" ? JSON.parse(this.state.home_collection_allowed) : "",
            "end": this.state.date,
            "sample_collection_address": address,
            "clinic_test_ids": this.state.tests.filter(a => a !== "").map(t => {
                return t.name
            }).map(item => {
                return item._id
            }),

            "notes": this.state.description,
            "local_start_time": this.state.slot,
        };
        if (this.state.clinicmaster_id !== "" && this.state.clinic_id !== "" && this.state.clickedId !== "" && this.state.date !== "" && this.state.slot !== "" && this.state.name !== "") {
            api.bookTest(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Test Booked Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/tests/request`))
                    // this.props.id.history.push(dashboardRouter(`/appointment/view/${json.data.data._id}`))
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };

    handleChangeStartDate(event) {
        this.setState({
            timeIntervalOpen: null,
            timeIntervalClose: null,
            date: (event).format('YYYY-MM-DD'),
            timeSlot: this.state.clinicDetail.clinic_timings[`${event.day() > 0 ? event.day() - 1 : 6}`],
            finalTime: []
        }, () => {
            if (this.state.timeSlot !== null)
                this.setState({
                    timeIntervalOpen: this.state.timeSlot.open_24 ? this.state.timingStatic.find(o => o.time === "12:00 AM") : this.state.timingStatic.find(o => o.time === this.state.timeSlot.open_time),
                    timeIntervalClose: this.state.timeSlot.open_24 ? this.state.timingStatic.find(o => o.time === "12:00 AM") : this.state.timingStatic.find(o => o.time === this.state.timeSlot.close_time),
                }, () => {
                    if (this.state.timeIntervalOpen !== undefined && this.state.timeIntervalClose !== undefined)
                        this.state.timeIntervalClose.count !== this.state.timeIntervalOpen.count ? this.setState({finalTime: this.newArray(this.state.timeIntervalClose.count, this.state.timeIntervalOpen.count)}) : this.setState({finalTime: timing})
                })
        });
    }

    uniqueObject(array, property) {
        var unique = {};
        var distinct = [];
        for (var i in array) {
            if (typeof (unique[array[i][property]]) == "undefined") {
                distinct.push(array[i]);
            }
            unique[array[i][property]] = 0;
        }
        return distinct;
    }

    calculateTotal() {
        let Total = 0;
        this.state.tests.map(t => {
            return t.name
        }).filter(a => a !== "").forEach(item => {
            Total = Total + (item.discounted_price !== 0 ? item.discounted_price : item.total ? item.total : item.total);
        })
        // this.props.tempCartList.length > 0 && this.props.tempCartList[0].items ? this.props.tempCartList[0].items.forEach(item => {
        //     Total = Total + item.price * item.quantity;
        // }) : null;
        return Total;
    }


    handleChangeTest(e, name, index) {
        let a = this.state.tests.slice(); //creates the clone of the state
        a[index][name] = e;
        this.setState({tests: this.state.tests})
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        }).catch(error => {
            this.props.serverError(true);
        });
    }

    newArray(length, start) {
        const ar = timing;
        var cloneArray = ar.slice();
        cloneArray.length = length;
        const newArray = cloneArray.splice(start);
        return newArray
    }
}

const mapStateToProps = ({global}) => ({
    searchPrescription: global.searchPrescription,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    serverError
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddTests));



// WEBPACK FOOTER //
// ./src/components/Tests/bookTests.jsx